/* eslint-disable function-paren-newline */
/* eslint-disable standard/computed-property-even-spacing */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import firebase from 'firebase'

const BASE_URL = 'https://us-central1-makeup-bauhn-se.cloudfunctions.net'

const updatePortfolio = async (portfolioConfig, token) => {
	const output = axios.post(`${BASE_URL}/admin/portfolio`, portfolioConfig, {
		headers: { Authorization: token }
	})
	return output
}

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		portfolioConfig: [],
		token: '',
		configChanged: false,
		selectedCategory: 'all'
	},

	mutations: {
		setConfig(state, portfolioConfig) {
			state.portfolioConfig = portfolioConfig
		},

		setToken(state, token) {
			state.token = token
		},

		setCategory(state, category) {
			state.selectedCategory = category
		},

		addImage(state, image) {
			state.portfolioConfig.push(image)
		},

		changePortfolioImageSize(state, { image, desiredSize }) {
			state.portfolioConfig = state.portfolioConfig.map(img => {
				if (img.file === image.file) {
					img.flex = desiredSize
				}
				return img
			})
			state.configChanged = true
		},

		changePortfolioImageOrder(state, { image, direction }) {
			const index = state.portfolioConfig.findIndex(
				img => img.file === image.file
			)
			if (index > -1) {
				const clone = [...state.portfolioConfig]
				if (direction === 'up' && index > 0) {
					const temp = { ...clone[index] }
					clone[index] = clone[index - 1]
					clone[index - 1] = temp
					state.configChanged = true
				}

				if (direction === 'down' && index < clone.length - 1) {
					const temp = { ...clone[index] }
					clone[index] = clone[index + 1]
					clone[index + 1] = temp
					state.configChanged = true
				}
				state.portfolioConfig = clone
			}
		},

		changePortfolioImageDetails(state, image) {
			const clone = [...state.portfolioConfig]

			state.portfolioConfig = clone.map(img => {
				if (img.file === image.file) {
					img = image
				}
				return img
			})
			state.configChanged = true
		}
	},
	actions: {
		/**
		 * Loads the data to be displayed in the portfolio at once due to prevent the delay from a cold cloud function.
		 */
		loadConfig: async context => {
			try {
				const res = (await axios.get(`${BASE_URL}/data/`)).data
				const tempArray = []

				// Convert from object to array
				Object.keys(res).forEach(key => {
					tempArray.push(res[key])
				})

				const filenames = tempArray.map(f => {
					return new Promise((resolve, reject) => {
						firebase
							.storage()
							.ref(f.file)
							.getDownloadURL()
							.then(url => {
								f.url = url
								resolve(f)
							})
							.catch(err => {
								reject(err)
							})
					})
				})

				const images = await Promise.all(filenames).catch(err => {
					console.log(err)
				})

				context.commit('setConfig', images)
			} catch (err) {
				console.log(err)
			}
		},

		updatePortfolioImageSize(context, payload) {
			context.commit('changePortfolioImageSize', payload)
			updatePortfolio(context.state.portfolioConfig, context.state.token)
				.then(res => console.log(res))
				.catch(err => console.log(err))
		},

		updatePortfolioImageOrder(context, payload) {
			context.commit('changePortfolioImageOrder', payload)
			updatePortfolio(context.state.portfolioConfig, context.state.token)
				.then(res => console.log(res))
				.catch(err => console.log(err))
		},

		updatePortfolioImageDetails(context, payload) {
			context.commit('changePortfolioImageDetails', payload)
			updatePortfolio(context.state.portfolioConfig, context.state.token)
				.then(res => console.log(res))
				.catch(err => console.log(err))
		},

		async addImageToPortfolio({ state, commit }, payload) {
			commit('addImage', payload)
			const output = await updatePortfolio(
				state.portfolioConfig,
				state.token
			)

			return output
		}
	}
})
